'use client';

import type { ReactNode } from 'react';
import { Field, type ReservationStepProps } from '../reservation-form';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Link from '@eliadmin/core/src/components/link';
import { Checkbox } from '@eliadmin/core/src/components/ui/checkbox';

export function ReservationContactForm({ form, services }: ReservationStepProps) {
  const selectedServiceId = form.watch('reservation_service');

  const gdpr = form.watch('gdpr');
  const vop = form.watch('vop');

  const checkAll = gdpr && vop;

  const handleCheckAll = (checked: boolean) => {
    form.setValue('gdpr', checked);
    form.setValue('vop', checked);
  };

  return (
    <div className="grid w-full max-w-[588px] grid-cols-12 gap-[18px] rounded-[24px] bg-primary-foreground p-[18px] sm:gap-5 sm:p-5 lg:gap-6 lg:p-6">
      <Field
        required
        control={form.control}
        name="name"
        placeholder="Meno"
        className={{ wrapper: 'col-span-12 w-full sm:col-span-6' }}
        options={services?.map(p => ({ value: p.id, label: `${p.name}` }))}
        selectedService={services?.find(p => String(p.id) === String(selectedServiceId))}
        services={services}
      />
      <Field
        required
        control={form.control}
        name="surname"
        placeholder="Priezvisko"
        className={{ wrapper: 'col-span-12 w-full sm:col-span-6' }}
        options={services?.map(p => ({ value: p.id, label: `${p.name}` }))}
        selectedService={services?.find(p => String(p.id) === String(selectedServiceId))}
        services={services}
      />
      <Field
        required
        control={form.control}
        name="email"
        placeholder="E-mail"
        className={{ wrapper: 'col-span-12 w-full sm:col-span-6' }}
        options={services?.map(p => ({ value: p.id, label: `${p.name}` }))}
        selectedService={services?.find(p => String(p.id) === String(selectedServiceId))}
        services={services}
      />
      <Field
        required
        control={form.control}
        name="phone"
        placeholder="Telefón"
        className={{ wrapper: 'col-span-12 w-full sm:col-span-6' }}
        options={services?.map(p => ({ value: p.id, label: `${p.name}` }))}
        selectedService={services?.find(p => String(p.id) === String(selectedServiceId))}
        services={services}
      />
      {/* <Field
        required
        control={form.control}
        name="text"
        placeholder="Poznámka"
        type="textarea"
        className={{ wrapper: 'col-span-12 w-full' }}
        options={services?.map(p => ({ value: p.id, label: `${p.name}` }))}
        selectedService={services?.find(p => String(p.id) === String(selectedServiceId))}
        services={services}
      /> */}

      <div className="col-span-12 flex w-full flex-col items-start justify-start gap-2">
        <FormFieldWrapper>
          <Checkbox
            checked={checkAll}
            onCheckedChange={checked => handleCheckAll(checked === true)}
            className={cn('ea-reservation-contact-form-check')}
          />
          <label className="text-sm font-medium">Označiť všetky možnosti</label>
        </FormFieldWrapper>

        <FormFieldWrapper className="ml-2 items-start sm:ml-3 lg:ml-4">
          <Checkbox
            checked={gdpr || false}
            onCheckedChange={checked => form.setValue('gdpr', checked === true)}
          />
          <label className="text-sm font-medium">
            Súhlasím so{' '}
            <Link href="/vseobecne-obchodne-podmienky">všeobecnými obchodnými podmienkami</Link> a{' '}
            <Link href="/ochrana-osobnych-udajov">spracovaním osobných údajov</Link> pre Kaderníctvo
            KAKADU na marketingové účely a súhlasím s ich použitím pre účely priameho marketingu.
          </label>
        </FormFieldWrapper>
        <FormFieldWrapper className="ml-2 items-start sm:ml-3 lg:ml-4">
          <Checkbox
            checked={vop || false}
            onCheckedChange={checked => form.setValue('vop', checked === true)}
          />
          <label className="text-sm font-medium">
            Súhlasím s <Link href="/prevadzkovy-poriadok">prevádzkovým poriadkom</Link>.
          </label>
        </FormFieldWrapper>
      </div>
    </div>
  );
}

function FormFieldWrapper({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={cn(
        'col-span-12 flex items-center justify-start gap-4 sm:gap-5 lg:gap-6',
        className,
      )}
    >
      {children}
    </div>
  );
}
